import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const ManifestLoader: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');

  useEffect(() => {
    document.body.style.backgroundColor = 'hsl(var(--background))';
    return () => {
      document.body.style.backgroundColor = '';
    };
  }, []);

  useEffect(() => {
    const patientId = searchParams.get('patientId');
    const folderId = searchParams.get('folderId');

    if (!patientId || !folderId) {
      setError('Missing required query parameters: patientId and folderId.');
      return;
    }

    const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8043';
    const manifestUrl = `${backendUrl}/api/v1/dicom/patient/manifest.json?patientId=${patientId}&folderId=${folderId}`;
    navigate(`/segmentation/dicomjson?url=${encodeURIComponent(manifestUrl)}`, { replace: true });
  }, [searchParams, navigate]);

  if (error) {
    return (
      <div className="flex h-screen w-screen items-center justify-center bg-background">
        <div className="text-center">
          <h2 className="mb-2 text-xl font-semibold text-red-400">Error</h2>
          <p className="text-gray-300">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center bg-background">
      <div className="border-border border-t-primary h-10 w-10 animate-spin rounded-full border-4" />
      <p className="text-muted-foreground mt-4">Loading study...</p>
    </div>
  );
};

export default ManifestLoader;
